import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import {
  fetchGalleryImages,
  getGalleryThumbnailUrl,
  pickOneImagePerCountry,
} from '../../services/galleryService';

const GalleryCarousel: React.FC = () => {
  const [images, setImages] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadGalleryImages = async () => {
      try {
        setLoading(true);
        const galleryImages = await fetchGalleryImages();
        const imagePaths = pickOneImagePerCountry(galleryImages).map((item) =>
          getGalleryThumbnailUrl(item)
        );
        
        setImages(imagePaths);
      } catch (e) {
        console.error('Failed to load gallery images:', e);
        // Keep images empty array on error
        setImages([]);
      } finally {
        setLoading(false);
      }
    };
    loadGalleryImages();
  }, []);

  // Don't render if loading or no images
  if (loading || images.length === 0) {
    return null;
  }

  const duplicated = [...images, ...images];

  return (
    <section className="py-4 bg-neutral-white">
      <div className="container">
        <motion.div
          className="overflow-hidden rounded-2xl border border-neutral-medium-gray"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="carousel-marquee">
            <div className="carousel-track">
              {duplicated.map((src, idx) => (
                <div className="carousel-item" key={`${src}-${idx}`}>
                  <img
                    src={src}
                    alt="Travel gallery"
                    loading="lazy"
                    decoding="async"
                    onError={(e) => {
                      // Hide broken images
                      (e.target as HTMLImageElement).style.display = 'none';
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default GalleryCarousel;


